/**
 * 스키마 표류(AUDIT_1030 A5) — 코드는 있으나 DB 객체가 없는 기능의 «꺼짐» 스위치 정본.
 *
 * 2026-10-30 읽기 SQL 실측: 아래 테이블·함수가 public 스키마에 없다.
 *   stock_comment_likes · stock_comment_reactions · apt_review_likes · stock_watchlist · rpc aggregate_external_referrers
 * 그래서 버튼이 매번 실패하고, 크론은 헛돈다. 오너 승인(A5): UI 버튼은 숨기고 라우트·크론은 «disabled: table missing» 로 일찍 끝낸다.
 * 코드는 지우지 않는다 — 되살리려면 ① DB 객체를 마이그레이션으로 만들고 ② 여기 값을 false 로 바꾼다.
 */
export const SCHEMA_GAPS = {
  /** components/StockComments — 공감 버튼 */
  stockCommentLikes: true,
  /** components/StockComments — 이모지 반응 */
  stockCommentReactions: true,
  /** components/AptReviewSection 좋아요 버튼 · api/apt/reviews/[id]/like */
  aptReviewLikes: true,
  /** api/stock/watchlist POST(호출부 0 · GET 은 user_watchlist 를 읽어 영향 없음) */
  stockWatchlist: true,
  /** cron/backlink-sync — rpc aggregate_external_referrers */
  backlinkAggregateRpc: true,
} as const;

export type SchemaGapKey = keyof typeof SCHEMA_GAPS;

/** 서버 라우트·크론이 일찍 끝날 때 남기는 표준 로그 문구. */
export function schemaGapLog(scope: string, missing: string): string {
  return `[${scope}] disabled: table missing (${missing}) — lib/schema-gaps.ts`;
}
